import React, { Component } from 'react';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

class AssetCard extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { item } = this.props;
        return (
            <div className="flex-centered">
                <div>
                    <p style={{ fontWeight: 600 }}>{item?.engine_type && item?.engine_type?.engine_family?.name || ""}</p>
                    <span>{item.asset_type == 1 ? item.aircraft_type ? item.aircraft_type.name : '--' : item.engine_type ? item.engine_type.name : '--'}{item.asset_type == 1 ? item.model && '/' + item.model : ''}</span>
                    {/* {
                  item.ownership_type !== undefined && item.ownership_type.value == 2 && item.owner_portfolio.name && item.owner_portfolio.name != ''  ?
                  <ul className="list-inline">
                    <li className="list-inline-item portfolio-type">Managed</li>
                    <li className="list-inline-item">
                    <Tooltip title={`Portfolio: ${item.owner_portfolio.name}`} arrow>
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                    </li>
                  </ul> : null
                } */}
                    {item?.owner?.name && item?.owner?.name === "Managed" ?
                        <span style={{ backgroundColor: "#56b4da", color: " #FFFFFF", borderRadius: "4px", padding: "2px 10px", marginRight: "3px", marginLeft: "5px" }}>Managed</span>
                        : null
                    }
                </div>
            </div>
        )
    }
}
export default AssetCard;